/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: bvRZj1oZhhFBeMnkX2LkQu
// Component: JVoKw0cfx-VJ

import * as React from "react";

import Head from "next/head";
import Link, { LinkProps } from "next/link";
import { useRouter } from "next/router";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import { FormProvider } from "@myevaluations/myevals-plasmic-utils/dist/code-components/form/FormProvider"; // plasmic-import: R4jbURjT8nMH/codeComponent
import MultiFactorAuthModal from "../../MultiFactorAuthModal"; // plasmic-import: t5CKmWfTpe_O/component
import ServiceMessage from "../../ServiceMessage"; // plasmic-import: OnWTFNPo14Tf/component
import Notice from "../../Notice"; // plasmic-import: m89ZcmmDcMEs/component
import { FormControlProvider } from "@myevaluations/myevals-plasmic-utils/dist/code-components/form/FormControlProvider"; // plasmic-import: v9MLUrEpQF_1/codeComponent
import { OnChangeProvider } from "@myevaluations/myevals-plasmic-utils/dist/code-components/OnChangeProvider/OnChangeProvider"; // plasmic-import: aQR8NTRfsmne/codeComponent
import TextInput from "../../TextInput"; // plasmic-import: kx7Qgd3B-3Xa/component
import Button from "../../Button"; // plasmic-import: In8OlLBJG380/component
import SpinnerIcon from "../../SpinnerIcon"; // plasmic-import: 0R7aXYvaG7Fy/component
import LoginFormSecurity from "../../LoginFormSecurity"; // plasmic-import: 8KallFSuh79l/component
import LoginFormResources from "../../LoginFormResources"; // plasmic-import: cDS26z8R0NcM/component
import { _useGlobalVariants } from "./plasmic"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import projectcss from "./plasmic.module.css"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectcss
import sty from "./PlasmicLoginForm.module.css"; // plasmic-import: JVoKw0cfx-VJ/css

import SearchSvgIcon from "./icons/PlasmicIcon__SearchSvg"; // plasmic-import: 4h8B6qj-XIZa/icon
import IconIcon from "./icons/PlasmicIcon__Icon"; // plasmic-import: kE4-BqL_BWFR/icon

import { zod as __fn_zod } from "@myevaluations/myevals-plasmic-utils/dist/custom-functions/zod"; // plasmic-import: zod/customFunction

createPlasmicElementProxy;

export type PlasmicLoginForm__VariantMembers = {};
export type PlasmicLoginForm__VariantsArgs = {};
type VariantPropType = keyof PlasmicLoginForm__VariantsArgs;
export const PlasmicLoginForm__VariantProps = new Array<VariantPropType>();

export type PlasmicLoginForm__ArgsType = {
  onHelpClick?: () => void;
  isLoggingWithToken?: boolean;
  usernameParam?: string;
};
type ArgPropType = keyof PlasmicLoginForm__ArgsType;
export const PlasmicLoginForm__ArgProps = new Array<ArgPropType>(
  "onHelpClick",
  "isLoggingWithToken",
  "usernameParam"
);

export type PlasmicLoginForm__OverridesType = {
  root?: Flex__<"div">;
  loginForm?: Flex__<typeof FormProvider>;
  multiFactorAuthModal?: Flex__<typeof MultiFactorAuthModal>;
  section?: Flex__<"section">;
  wrapper?: Flex__<"div">;
  heading?: Flex__<"div">;
  logo?: Flex__<"a"> & Partial<LinkProps>;
  link?: Flex__<"div">;
  form?: Flex__<"form">;
  header?: Flex__<"div">;
  title?: Flex__<"h1">;
  desc?: Flex__<"p">;
  serviceMessage?: Flex__<typeof ServiceMessage>;
  notice?: Flex__<typeof Notice>;
  bottom?: Flex__<"div">;
  usernameProvider?: Flex__<typeof FormControlProvider>;
  usernameWrapper?: Flex__<"div">;
  label?: Flex__<"label">;
  onChangeProvider?: Flex__<typeof OnChangeProvider>;
  usernameInput?: Flex__<typeof TextInput>;
  passwordProvider?: Flex__<typeof FormControlProvider>;
  password?: Flex__<"div">;
  passwordLabels?: Flex__<"div">;
  label7?: Flex__<"label">;
  label9?: Flex__<"a"> & Partial<LinkProps>;
  passwordInput?: Flex__<typeof TextInput>;
  logInBtn?: Flex__<typeof Button>;
  text?: Flex__<"div">;
  spinnerIcon?: Flex__<typeof SpinnerIcon>;
  loginFormSecurity?: Flex__<typeof LoginFormSecurity>;
  loginFormResources?: Flex__<typeof LoginFormResources>;
  line?: Flex__<"div">;
};

export interface DefaultLoginFormProps {
  onHelpClick?: () => void;
  isLoggingWithToken?: boolean;
  usernameParam?: string;
  className?: string;
}

const $$ = {
  zod: __fn_zod
};

function useNextRouter() {
  try {
    return useRouter();
  } catch {}
  return undefined;
}

function PlasmicLoginForm__RenderFunc(props: {
  variants: PlasmicLoginForm__VariantsArgs;
  args: PlasmicLoginForm__ArgsType;
  overrides: PlasmicLoginForm__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {
          isLoggingWithToken: false
        },
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const __nextRouter = useNextRouter();

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const globalVariants = _useGlobalVariants();

  const stateSpecs: Parameters<typeof useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "usernameInput.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) =>
          (() => {
            try {
              return $ctx.usernameProvider.field.value;
            } catch (e) {
              if (
                e instanceof TypeError ||
                e?.plasmicType === "PlasmicUndefinedDataError"
              ) {
                return undefined;
              }
              throw e;
            }
          })()
      },
      {
        path: "passwordInput.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) =>
          (() => {
            try {
              return $ctx.passwordProvider.field.value;
            } catch (e) {
              if (
                e instanceof TypeError ||
                e?.plasmicType === "PlasmicUndefinedDataError"
              ) {
                return undefined;
              }
              throw e;
            }
          })()
      },
      {
        path: "isFormSubmitting",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $ctx }) => false
      },
      {
        path: "multiFactorAuthModal.open",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $ctx }) => false
      },
      {
        path: "multiFactorAuthModal.factors",
        type: "private",
        variableType: "array",
        initFunc: ({ $props, $state, $queries, $ctx }) => []
      },
      {
        path: "multiFactorAuthModal.isChallengeSubmitting",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $ctx }) => false
      },
      {
        path: "multiFactorAuthModal.methodSelected",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $ctx }) => false
      },
      {
        path: "multiFactorAuthModal.cooldown",
        type: "private",
        variableType: "object",
        initFunc: ({ $props, $state, $queries, $ctx }) => ({
          Email: 0,
          SMS: 0,
          Password: 0
        })
      }
    ],
    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });

  const styleTokensClassNames = _useStyleTokens();

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        styleTokensClassNames,
        sty.root
      )}
    >
      <FormProvider
        data-plasmic-name={"loginForm"}
        data-plasmic-override={overrides.loginForm}
        className={classNames("__wab_instance", sty.loginForm)}
        contextName={"loginForm"}
        mode={"all"}
        reValidateMode={"onChange"}
        zodValidationSchema={(() => {
          try {
            return (() => {
              const z = $$.zod();
              const schema = z.object({
                username: z.string().nonempty(),
                password: z.string().nonempty()
              });
              return schema;
            })();
          } catch (e) {
            if (
              e instanceof TypeError ||
              e?.plasmicType === "PlasmicUndefinedDataError"
            ) {
              return undefined;
            }
            throw e;
          }
        })()}
      >
        <DataCtxReader__>
          {$ctx => (
            <React.Fragment>
              <MultiFactorAuthModal
                data-plasmic-name={"multiFactorAuthModal"}
                data-plasmic-override={overrides.multiFactorAuthModal}
                action={"login process"}
                className={classNames(
                  "__wab_instance",
                  sty.multiFactorAuthModal
                )}
                cooldown={generateStateValueProp($state, [
                  "multiFactorAuthModal",
                  "cooldown"
                ])}
                factors={generateStateValueProp($state, [
                  "multiFactorAuthModal",
                  "factors"
                ])}
                isChallengeSubmitting={generateStateValueProp($state, [
                  "multiFactorAuthModal",
                  "isChallengeSubmitting"
                ])}
                methodSelected={generateStateValueProp($state, [
                  "multiFactorAuthModal",
                  "methodSelected"
                ])}
                onCooldownChange={async (...eventArgs: any) => {
                  generateStateOnChangeProp($state, [
                    "multiFactorAuthModal",
                    "cooldown"
                  ]).apply(null, eventArgs);

                  if (
                    eventArgs.length > 1 &&
                    eventArgs[1] &&
                    eventArgs[1]._plasmic_state_init_
                  ) {
                    return;
                  }
                }}
                onFactorsChange={async (...eventArgs: any) => {
                  generateStateOnChangeProp($state, [
                    "multiFactorAuthModal",
                    "factors"
                  ]).apply(null, eventArgs);

                  if (
                    eventArgs.length > 1 &&
                    eventArgs[1] &&
                    eventArgs[1]._plasmic_state_init_
                  ) {
                    return;
                  }
                }}
                onIsChallengeSubmittingChange={async (...eventArgs: any) => {
                  generateStateOnChangeProp($state, [
                    "multiFactorAuthModal",
                    "isChallengeSubmitting"
                  ]).apply(null, eventArgs);

                  if (
                    eventArgs.length > 1 &&
                    eventArgs[1] &&
                    eventArgs[1]._plasmic_state_init_
                  ) {
                    return;
                  }
                }}
                onMethodSelectedChange={async (...eventArgs: any) => {
                  generateStateOnChangeProp($state, [
                    "multiFactorAuthModal",
                    "methodSelected"
                  ]).apply(null, eventArgs);

                  if (
                    eventArgs.length > 1 &&
                    eventArgs[1] &&
                    eventArgs[1]._plasmic_state_init_
                  ) {
                    return;
                  }
                }}
                onOpenChange={async (...eventArgs: any) => {
                  generateStateOnChangeProp($state, [
                    "multiFactorAuthModal",
                    "open"
                  ]).apply(null, eventArgs);

                  if (
                    eventArgs.length > 1 &&
                    eventArgs[1] &&
                    eventArgs[1]._plasmic_state_init_
                  ) {
                    return;
                  }

                  (async val => {
                    const $steps = {};

                    $steps["updateIsFormSubmitting"] =
                      !$state.multiFactorAuthModal.open &&
                      $state.isFormSubmitting
                        ? (() => {
                            const actionArgs = {
                              variable: {
                                objRoot: $state,
                                variablePath: ["isFormSubmitting"]
                              },
                              operation: 0,
                              value: false
                            };
                            return (({
                              variable,
                              value,
                              startIndex,
                              deleteCount
                            }) => {
                              if (!variable) {
                                return;
                              }
                              const { objRoot, variablePath } = variable;

                              $stateSet(objRoot, variablePath, value);
                              return value;
                            })?.apply(null, [actionArgs]);
                          })()
                        : undefined;
                    if (
                      $steps["updateIsFormSubmitting"] != null &&
                      typeof $steps["updateIsFormSubmitting"] === "object" &&
                      typeof $steps["updateIsFormSubmitting"].then ===
                        "function"
                    ) {
                      $steps["updateIsFormSubmitting"] = await $steps[
                        "updateIsFormSubmitting"
                      ];
                    }
                  }).apply(null, eventArgs);
                }}
                onVerify={async (code, deliveryMethod) => {
                  const $steps = {};

                  $steps["runCode"] = true
                    ? (() => {
                        const actionArgs = {
                          customFunction: async () => {
                            return (async () => {
                              async function onVerify() {
                                const onSubmit = async values => {
                                  const url = new URL(
                                    "/New/Login.ashx",
                                    window.location.href
                                  );
                                  const urlParams = new URLSearchParams(
                                    window.location.search
                                  );
                                  ["tempid", "autovoluntary", "qrid"].forEach(
                                    param => {
                                      if (urlParams.has(param))
                                        url.searchParams.append(
                                          param,
                                          urlParams.get(param)
                                        );
                                    }
                                  );
                                  if (code)
                                    url.searchParams.append("authCode", code);
                                  if (deliveryMethod)
                                    url.searchParams.append(
                                      "deliveryMethod",
                                      deliveryMethod
                                    );
                                  const response = await fetch(url, {
                                    method: "POST",
                                    body: JSON.stringify({
                                      username: values.username,
                                      password: values.password
                                    }),
                                    headers: {
                                      "Content-type":
                                        "application/json; charset=UTF-8"
                                    }
                                  });
                                  if (response.ok) {
                                    const responseData = await response.json();
                                    if (responseData.title) {
                                      $ctx.toast.show({
                                        type: responseData?.factors
                                          ? "info"
                                          : "success",
                                        duration: 5000,
                                        title: responseData.title,
                                        description: responseData.description
                                      });
                                    }
                                    const usernameParam =
                                      urlParams.get("username");
                                    const redirectParam =
                                      urlParams.get("redirect");
                                    let redirectUrl =
                                      redirectParam &&
                                      values.username === usernameParam
                                        ? redirectParam
                                        : responseData.redirect;
                                    if (redirectUrl) {
                                      if (redirectUrl.startsWith("~")) {
                                        redirectUrl = redirectUrl.replace(
                                          /^~/,
                                          ""
                                        );
                                      }
                                      if (!redirectUrl.startsWith("http")) {
                                        if (!redirectUrl.startsWith("/")) {
                                          redirectUrl = `/${redirectUrl}`;
                                        }
                                        redirectUrl = `${window.location.origin}${redirectUrl}`;
                                      }
                                      window.location.href = redirectUrl;
                                    }
                                  } else {
                                    const errorData = await response.json();
                                    $state.multiFactorAuthModal.isChallengeSubmitting =
                                      false;
                                    $ctx.toast.show({
                                      id: 1,
                                      type: "error",
                                      duration: 5000,
                                      title: errorData.error.title,
                                      description: errorData.error.description
                                    });
                                  }
                                };
                                return $ctx.loginForm.handleSubmit(onSubmit)();
                              }
                              return onVerify();
                            })();
                          }
                        };
                        return (({ customFunction }) => {
                          return customFunction();
                        })?.apply(null, [actionArgs]);
                      })()
                    : undefined;
                  if (
                    $steps["runCode"] != null &&
                    typeof $steps["runCode"] === "object" &&
                    typeof $steps["runCode"].then === "function"
                  ) {
                    $steps["runCode"] = await $steps["runCode"];
                  }
                }}
                open={generateStateValueProp($state, [
                  "multiFactorAuthModal",
                  "open"
                ])}
              />

              <section
                data-plasmic-name={"section"}
                data-plasmic-override={overrides.section}
                className={classNames(projectcss.all, sty.section)}
              >
                <div
                  data-plasmic-name={"wrapper"}
                  data-plasmic-override={overrides.wrapper}
                  className={classNames(projectcss.all, sty.wrapper)}
                >
                  <div
                    data-plasmic-name={"heading"}
                    data-plasmic-override={overrides.heading}
                    className={classNames(projectcss.all, sty.heading)}
                  >
                    {(
                      hasVariant(globalVariants, "mobile", "mobile")
                        ? true
                        : hasVariant(globalVariants, "mobile", "tabletPortrait")
                        ? true
                        : false
                    ) ? (
                      <PlasmicLink__
                        data-plasmic-name={"logo"}
                        data-plasmic-override={overrides.logo}
                        aria-label={"Home"}
                        className={classNames(
                          projectcss.all,
                          projectcss.a,
                          sty.logo
                        )}
                        component={Link}
                        href={`/`}
                        platform={"nextjs"}
                        title={"Home"}
                      >
                        <PlasmicImg__
                          alt={""}
                          className={classNames(sty.img__m64Y8)}
                          displayHeight={
                            hasVariant(globalVariants, "mobile", "mobileXSmall")
                              ? "32px"
                              : "36px"
                          }
                          displayMaxHeight={"none"}
                          displayMaxWidth={"100%"}
                          displayMinHeight={"0"}
                          displayMinWidth={"0"}
                          displayWidth={
                            hasVariant(globalVariants, "mobile", "mobileXSmall")
                              ? "180px"
                              : "205px"
                          }
                          loader={"plasmic"}
                          loading={"lazy"}
                          src={{
                            src: "https://site-assets.plasmic.app/aaa816ed07b668d50951fc51e9c19c16.svg",
                            fullWidth: 170.666,
                            fullHeight: 29.831,
                            aspectRatio: 5.7
                          }}
                        />
                      </PlasmicLink__>
                    ) : null}
                    <div
                      data-plasmic-name={"link"}
                      data-plasmic-override={overrides.link}
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.link
                      )}
                    >
                      {hasVariant(globalVariants, "mobile", "mobile") ? (
                        <React.Fragment>
                          <React.Fragment>{""}</React.Fragment>
                          {
                            <PlasmicLink__
                              aria-label={"Open help logging in modal"}
                              className={classNames(
                                projectcss.all,
                                projectcss.a,
                                projectcss.__wab_text,
                                projectcss.plasmic_default__inline,
                                sty.link___5Pv45
                              )}
                              component={Link}
                              onClick={async event => {
                                const $steps = {};

                                $steps["runOnHelpClick"] = true
                                  ? (() => {
                                      const actionArgs = {
                                        eventRef: $props["onHelpClick"]
                                      };
                                      return (({ eventRef, args }) => {
                                        return eventRef?.(...(args ?? []));
                                      })?.apply(null, [actionArgs]);
                                    })()
                                  : undefined;
                                if (
                                  $steps["runOnHelpClick"] != null &&
                                  typeof $steps["runOnHelpClick"] ===
                                    "object" &&
                                  typeof $steps["runOnHelpClick"].then ===
                                    "function"
                                ) {
                                  $steps["runOnHelpClick"] = await $steps[
                                    "runOnHelpClick"
                                  ];
                                }
                              }}
                              platform={"nextjs"}
                              title={"Open help logging in modal"}
                            >
                              {hasVariant(globalVariants, "mobile", "mobile")
                                ? "Need Help?"
                                : hasVariant(
                                    globalVariants,
                                    "mobile",
                                    "tabletPortrait"
                                  )
                                ? "Need Help?"
                                : "Need Help Logging In?"}
                            </PlasmicLink__>
                          }
                          <React.Fragment>{""}</React.Fragment>
                        </React.Fragment>
                      ) : hasVariant(
                          globalVariants,
                          "mobile",
                          "tabletPortrait"
                        ) ? (
                        <React.Fragment>
                          <React.Fragment>{""}</React.Fragment>
                          {
                            <PlasmicLink__
                              aria-label={"Open help logging in modal"}
                              className={classNames(
                                projectcss.all,
                                projectcss.a,
                                projectcss.__wab_text,
                                projectcss.plasmic_default__inline,
                                sty.link___5Pv45
                              )}
                              component={Link}
                              onClick={async event => {
                                const $steps = {};

                                $steps["runOnHelpClick"] = true
                                  ? (() => {
                                      const actionArgs = {
                                        eventRef: $props["onHelpClick"]
                                      };
                                      return (({ eventRef, args }) => {
                                        return eventRef?.(...(args ?? []));
                                      })?.apply(null, [actionArgs]);
                                    })()
                                  : undefined;
                                if (
                                  $steps["runOnHelpClick"] != null &&
                                  typeof $steps["runOnHelpClick"] ===
                                    "object" &&
                                  typeof $steps["runOnHelpClick"].then ===
                                    "function"
                                ) {
                                  $steps["runOnHelpClick"] = await $steps[
                                    "runOnHelpClick"
                                  ];
                                }
                              }}
                              platform={"nextjs"}
                              title={"Open help logging in modal"}
                            >
                              {hasVariant(globalVariants, "mobile", "mobile")
                                ? "Need Help?"
                                : hasVariant(
                                    globalVariants,
                                    "mobile",
                                    "tabletPortrait"
                                  )
                                ? "Need Help?"
                                : "Need Help Logging In?"}
                            </PlasmicLink__>
                          }
                          <React.Fragment>{""}</React.Fragment>
                        </React.Fragment>
                      ) : (
                        <React.Fragment>
                          <React.Fragment>{""}</React.Fragment>
                          {
                            <PlasmicLink__
                              aria-label={"Open help logging in modal"}
                              className={classNames(
                                projectcss.all,
                                projectcss.a,
                                projectcss.__wab_text,
                                projectcss.plasmic_default__inline,
                                sty.link___5Pv45
                              )}
                              component={Link}
                              onClick={async event => {
                                const $steps = {};

                                $steps["runOnHelpClick"] = true
                                  ? (() => {
                                      const actionArgs = {
                                        eventRef: $props["onHelpClick"]
                                      };
                                      return (({ eventRef, args }) => {
                                        return eventRef?.(...(args ?? []));
                                      })?.apply(null, [actionArgs]);
                                    })()
                                  : undefined;
                                if (
                                  $steps["runOnHelpClick"] != null &&
                                  typeof $steps["runOnHelpClick"] ===
                                    "object" &&
                                  typeof $steps["runOnHelpClick"].then ===
                                    "function"
                                ) {
                                  $steps["runOnHelpClick"] = await $steps[
                                    "runOnHelpClick"
                                  ];
                                }
                              }}
                              platform={"nextjs"}
                              title={"Open help logging in modal"}
                            >
                              {hasVariant(globalVariants, "mobile", "mobile")
                                ? "Need Help?"
                                : hasVariant(
                                    globalVariants,
                                    "mobile",
                                    "tabletPortrait"
                                  )
                                ? "Need Help?"
                                : "Need Help Logging In?"}
                            </PlasmicLink__>
                          }
                          <React.Fragment>{""}</React.Fragment>
                        </React.Fragment>
                      )}
                    </div>
                  </div>
                  <form
                    data-plasmic-name={"form"}
                    data-plasmic-override={overrides.form}
                    className={classNames(projectcss.all, sty.form)}
                    onSubmit={async event => {
                      const $steps = {};

                      $steps["runCode"] = true
                        ? (() => {
                            const actionArgs = {
                              customFunction: async () => {
                                return (async () => {
                                  event.preventDefault();
                                  async function onFinish() {
                                    const onSubmit = async values => {
                                      try {
                                        $state.isFormSubmitting = true;
                                        const url = new URL(
                                          "/New/Login.ashx",
                                          window.location.href
                                        );
                                        const urlParams = new URLSearchParams(
                                          window.location.search
                                        );
                                        [
                                          "tempid",
                                          "autovoluntary",
                                          "qrid"
                                        ].forEach(param => {
                                          if (urlParams.has(param))
                                            url.searchParams.append(
                                              param,
                                              urlParams.get(param)
                                            );
                                        });
                                        const response = await fetch(url, {
                                          method: "POST",
                                          body: JSON.stringify({
                                            username: values.username,
                                            password: values.password,
                                            useDefaultFactor: false
                                          }),
                                          headers: {
                                            "Content-type":
                                              "application/json; charset=UTF-8"
                                          }
                                        });
                                        if (response.ok) {
                                          const responseData =
                                            await response.json();
                                          const factors = responseData.factors;
                                          if (factors) {
                                            $ctx.toast.show({
                                              id: 1,
                                              type: "info",
                                              duration: 5000,
                                              title: responseData.title,
                                              description:
                                                responseData.description
                                            });
                                            const formattedFactors =
                                              factors.map(f => ({
                                                value: f,
                                                default: f === "Email"
                                              }));
                                            if (
                                              !formattedFactors.some(
                                                f => f.default
                                              )
                                            ) {
                                              formattedFactors[0].default =
                                                true;
                                            }
                                            const defaultFactor =
                                              formattedFactors.find(
                                                f => f.default
                                              );
                                            if (
                                              defaultFactor &&
                                              formattedFactors.length === 1
                                            ) {
                                              $state.multiFactorAuthModal.cooldown[
                                                defaultFactor.value
                                              ] = 30;
                                            }
                                            $state.multiFactorAuthModal.factors =
                                              formattedFactors;
                                            $state.multiFactorAuthModal.methodSelected =
                                              formattedFactors.length === 1;
                                            $state.multiFactorAuthModal.open =
                                              true;
                                          } else {
                                            const usernameParam =
                                              urlParams.get("username");
                                            const redirectParam =
                                              urlParams.get("redirect");
                                            let redirectUrl;
                                            if (
                                              responseData.redirect &&
                                              responseData.redirect.includes(
                                                "/Security/PasswordChange.aspx?requireContactSetup=1&redirectPath="
                                              )
                                            ) {
                                              const baseUrl =
                                                responseData.redirect.split(
                                                  "&redirectPath="
                                                )[0];
                                              if (redirectParam) {
                                                redirectUrl = `${baseUrl}&redirectPath=${encodeURIComponent(
                                                  redirectParam
                                                )}`;
                                              } else {
                                                redirectUrl =
                                                  responseData.redirect;
                                              }
                                            } else {
                                              redirectUrl =
                                                redirectParam &&
                                                values.username ===
                                                  usernameParam
                                                  ? redirectParam
                                                  : responseData.redirect;
                                            }
                                            if (redirectUrl) {
                                              if (redirectUrl.startsWith("~")) {
                                                redirectUrl =
                                                  redirectUrl.replace(/^~/, "");
                                              }
                                              if (
                                                !redirectUrl.startsWith("http")
                                              ) {
                                                if (
                                                  !redirectUrl.startsWith("/")
                                                ) {
                                                  redirectUrl = `/${redirectUrl}`;
                                                }
                                                redirectUrl = `${window.location.origin}${redirectUrl}`;
                                              }
                                              window.location.href =
                                                redirectUrl;
                                            }
                                          }
                                        } else {
                                          const errorData =
                                            await response.json();
                                          $ctx.toast.show({
                                            id: 1,
                                            type: "error",
                                            duration: 5000,
                                            title: errorData.error.title,
                                            description:
                                              errorData.error.description
                                          });
                                          $state.isFormSubmitting = false;
                                        }
                                      } catch (error) {
                                        $ctx.toast.show({
                                          id: 1,
                                          type: "error",
                                          duration: 5000,
                                          title: "Login Failed",
                                          description:
                                            "Try again or contact us if issue persists"
                                        });
                                        $state.isFormSubmitting = false;
                                      }
                                    };
                                    const onError = () => {
                                      $ctx.toast.show({
                                        id: 1,
                                        type: "error",
                                        duration: 5000,
                                        title: "Incomplete Form",
                                        description:
                                          "Login or password fields cannot be empty"
                                      });
                                    };
                                    return $ctx.loginForm.handleSubmit(
                                      onSubmit,
                                      onError
                                    )();
                                  }
                                  return onFinish();
                                })();
                              }
                            };
                            return (({ customFunction }) => {
                              return customFunction();
                            })?.apply(null, [actionArgs]);
                          })()
                        : undefined;
                      if (
                        $steps["runCode"] != null &&
                        typeof $steps["runCode"] === "object" &&
                        typeof $steps["runCode"].then === "function"
                      ) {
                        $steps["runCode"] = await $steps["runCode"];
                      }
                    }}
                  >
                    <div
                      data-plasmic-name={"header"}
                      data-plasmic-override={overrides.header}
                      className={classNames(projectcss.all, sty.header)}
                    >
                      <h1
                        data-plasmic-name={"title"}
                        data-plasmic-override={overrides.title}
                        className={classNames(
                          projectcss.all,
                          projectcss.h1,
                          projectcss.__wab_text,
                          sty.title
                        )}
                      >
                        {"Login"}
                      </h1>
                      <p
                        data-plasmic-name={"desc"}
                        data-plasmic-override={overrides.desc}
                        className={classNames(
                          projectcss.all,
                          projectcss.p,
                          projectcss.__wab_text,
                          sty.desc
                        )}
                      >
                        {"Enter your details below"}
                      </p>
                    </div>
                    <ServiceMessage
                      data-plasmic-name={"serviceMessage"}
                      data-plasmic-override={overrides.serviceMessage}
                      className={classNames(
                        "__wab_instance",
                        sty.serviceMessage
                      )}
                      rounded={true}
                    />

                    {(() => {
                      try {
                        return $props.isLoggingWithToken;
                      } catch (e) {
                        if (
                          e instanceof TypeError ||
                          e?.plasmicType === "PlasmicUndefinedDataError"
                        ) {
                          return false;
                        }
                        throw e;
                      }
                    })() ? (
                      <Notice
                        data-plasmic-name={"notice"}
                        data-plasmic-override={overrides.notice}
                        className={classNames("__wab_instance", sty.notice)}
                      />
                    ) : null}
                    <div
                      data-plasmic-name={"bottom"}
                      data-plasmic-override={overrides.bottom}
                      className={classNames(projectcss.all, sty.bottom)}
                    >
                      <FormControlProvider
                        data-plasmic-name={"usernameProvider"}
                        data-plasmic-override={overrides.usernameProvider}
                        className={classNames(
                          "__wab_instance",
                          sty.usernameProvider
                        )}
                        contextName={"usernameProvider"}
                        fieldName={"username"}
                        formControl={(() => {
                          try {
                            return $ctx.loginForm.control;
                          } catch (e) {
                            if (
                              e instanceof TypeError ||
                              e?.plasmicType === "PlasmicUndefinedDataError"
                            ) {
                              return undefined;
                            }
                            throw e;
                          }
                        })()}
                      >
                        <DataCtxReader__>
                          {$ctx => (
                            <div
                              data-plasmic-name={"usernameWrapper"}
                              data-plasmic-override={overrides.usernameWrapper}
                              className={classNames(
                                projectcss.all,
                                sty.usernameWrapper
                              )}
                            >
                              <label
                                data-plasmic-name={"label"}
                                data-plasmic-override={overrides.label}
                                className={classNames(
                                  projectcss.all,
                                  projectcss.__wab_text,
                                  sty.label
                                )}
                              >
                                {"Username"}
                              </label>
                              <OnChangeProvider
                                data-plasmic-name={"onChangeProvider"}
                                data-plasmic-override={
                                  overrides.onChangeProvider
                                }
                                data={(() => {
                                  try {
                                    return $props.usernameParam;
                                  } catch (e) {
                                    if (
                                      e instanceof TypeError ||
                                      e?.plasmicType ===
                                        "PlasmicUndefinedDataError"
                                    ) {
                                      return undefined;
                                    }
                                    throw e;
                                  }
                                })()}
                                deepEqualCheck={true}
                                onChange={async data => {
                                  const $steps = {};

                                  $steps["runCode"] =
                                    $props.usernameParam ?? false
                                      ? (() => {
                                          const actionArgs = {
                                            customFunction: async () => {
                                              return (() => {
                                                $state.usernameInput.value =
                                                  $props.usernameParam;
                                                return $ctx.usernameProvider.field.onChange(
                                                  $props.usernameParam
                                                );
                                              })();
                                            }
                                          };
                                          return (({ customFunction }) => {
                                            return customFunction();
                                          })?.apply(null, [actionArgs]);
                                        })()
                                      : undefined;
                                  if (
                                    $steps["runCode"] != null &&
                                    typeof $steps["runCode"] === "object" &&
                                    typeof $steps["runCode"].then === "function"
                                  ) {
                                    $steps["runCode"] = await $steps["runCode"];
                                  }
                                }}
                                runOnMount={true}
                              />

                              {(() => {
                                const child$Props = {
                                  "aria-label": "Username",
                                  autoFocus: true,
                                  className: classNames(
                                    "__wab_instance",
                                    sty.usernameInput
                                  ),
                                  invalid: (() => {
                                    try {
                                      return $ctx.usernameProvider.fieldState
                                        .invalid;
                                    } catch (e) {
                                      if (
                                        e instanceof TypeError ||
                                        e?.plasmicType ===
                                          "PlasmicUndefinedDataError"
                                      ) {
                                        return [];
                                      }
                                      throw e;
                                    }
                                  })(),
                                  isDisabled: (() => {
                                    try {
                                      return $props.isLoggingWithToken;
                                    } catch (e) {
                                      if (
                                        e instanceof TypeError ||
                                        e?.plasmicType ===
                                          "PlasmicUndefinedDataError"
                                      ) {
                                        return [];
                                      }
                                      throw e;
                                    }
                                  })(),
                                  name: "username",
                                  onChange: async (...eventArgs: any) => {
                                    ((...eventArgs) => {
                                      generateStateOnChangeProp($state, [
                                        "usernameInput",
                                        "value"
                                      ])(
                                        (e => e.target?.value).apply(
                                          null,
                                          eventArgs
                                        )
                                      );
                                    }).apply(null, eventArgs);

                                    if (
                                      eventArgs.length > 1 &&
                                      eventArgs[1] &&
                                      eventArgs[1]._plasmic_state_init_
                                    ) {
                                      return;
                                    }

                                    (async event => {
                                      const $steps = {};

                                      $steps["runCode"] = true
                                        ? (() => {
                                            const actionArgs = {
                                              customFunction: async () => {
                                                return $ctx.usernameProvider.field.onChange(
                                                  event.target.value
                                                );
                                              }
                                            };
                                            return (({ customFunction }) => {
                                              return customFunction();
                                            })?.apply(null, [actionArgs]);
                                          })()
                                        : undefined;
                                      if (
                                        $steps["runCode"] != null &&
                                        typeof $steps["runCode"] === "object" &&
                                        typeof $steps["runCode"].then ===
                                          "function"
                                      ) {
                                        $steps["runCode"] = await $steps[
                                          "runCode"
                                        ];
                                      }
                                    }).apply(null, eventArgs);
                                  },
                                  placeholder: ``,
                                  required: false,
                                  size: "large",
                                  type: "text",
                                  value:
                                    generateStateValueProp($state, [
                                      "usernameInput",
                                      "value"
                                    ]) ?? ""
                                };

                                initializePlasmicStates(
                                  $state,
                                  [
                                    {
                                      name: "usernameInput.value",
                                      initFunc: ({
                                        $props,
                                        $state,
                                        $queries
                                      }) =>
                                        (() => {
                                          try {
                                            return $ctx.usernameProvider.field
                                              .value;
                                          } catch (e) {
                                            if (
                                              e instanceof TypeError ||
                                              e?.plasmicType ===
                                                "PlasmicUndefinedDataError"
                                            ) {
                                              return undefined;
                                            }
                                            throw e;
                                          }
                                        })()
                                    }
                                  ],
                                  []
                                );
                                return (
                                  <TextInput
                                    data-plasmic-name={"usernameInput"}
                                    data-plasmic-override={
                                      overrides.usernameInput
                                    }
                                    {...child$Props}
                                  />
                                );
                              })()}
                            </div>
                          )}
                        </DataCtxReader__>
                      </FormControlProvider>
                      <FormControlProvider
                        data-plasmic-name={"passwordProvider"}
                        data-plasmic-override={overrides.passwordProvider}
                        className={classNames(
                          "__wab_instance",
                          sty.passwordProvider
                        )}
                        contextName={"passwordProvider"}
                        fieldName={"password"}
                        formControl={(() => {
                          try {
                            return $ctx.loginForm.control;
                          } catch (e) {
                            if (
                              e instanceof TypeError ||
                              e?.plasmicType === "PlasmicUndefinedDataError"
                            ) {
                              return undefined;
                            }
                            throw e;
                          }
                        })()}
                      >
                        <DataCtxReader__>
                          {$ctx => (
                            <div
                              data-plasmic-name={"password"}
                              data-plasmic-override={overrides.password}
                              className={classNames(
                                projectcss.all,
                                sty.password
                              )}
                            >
                              <div
                                data-plasmic-name={"passwordLabels"}
                                data-plasmic-override={overrides.passwordLabels}
                                className={classNames(
                                  projectcss.all,
                                  sty.passwordLabels
                                )}
                              >
                                <label
                                  data-plasmic-name={"label7"}
                                  data-plasmic-override={overrides.label7}
                                  className={classNames(
                                    projectcss.all,
                                    projectcss.__wab_text,
                                    sty.label7
                                  )}
                                >
                                  {"Password"}
                                </label>
                                <PlasmicLink__
                                  data-plasmic-name={"label9"}
                                  data-plasmic-override={overrides.label9}
                                  aria-label={"Go to forgot password page"}
                                  className={classNames(
                                    projectcss.all,
                                    projectcss.a,
                                    projectcss.__wab_text,
                                    sty.label9
                                  )}
                                  component={Link}
                                  href={`/forgot-password`}
                                  platform={"nextjs"}
                                  title={"Go to forgot password page"}
                                >
                                  {"Forgot Password?"}
                                </PlasmicLink__>
                              </div>
                              {(() => {
                                const child$Props = {
                                  "aria-label": "Password",
                                  className: classNames(
                                    "__wab_instance",
                                    sty.passwordInput
                                  ),
                                  invalid: (() => {
                                    try {
                                      return $ctx.passwordProvider.fieldState
                                        .invalid;
                                    } catch (e) {
                                      if (
                                        e instanceof TypeError ||
                                        e?.plasmicType ===
                                          "PlasmicUndefinedDataError"
                                      ) {
                                        return [];
                                      }
                                      throw e;
                                    }
                                  })(),
                                  isDisabled: (() => {
                                    try {
                                      return $props.isLoggingWithToken;
                                    } catch (e) {
                                      if (
                                        e instanceof TypeError ||
                                        e?.plasmicType ===
                                          "PlasmicUndefinedDataError"
                                      ) {
                                        return [];
                                      }
                                      throw e;
                                    }
                                  })(),
                                  name: "password",
                                  onChange: async (...eventArgs: any) => {
                                    ((...eventArgs) => {
                                      generateStateOnChangeProp($state, [
                                        "passwordInput",
                                        "value"
                                      ])(
                                        (e => e.target?.value).apply(
                                          null,
                                          eventArgs
                                        )
                                      );
                                    }).apply(null, eventArgs);

                                    if (
                                      eventArgs.length > 1 &&
                                      eventArgs[1] &&
                                      eventArgs[1]._plasmic_state_init_
                                    ) {
                                      return;
                                    }

                                    (async event => {
                                      const $steps = {};

                                      $steps["runCode"] = true
                                        ? (() => {
                                            const actionArgs = {
                                              customFunction: async () => {
                                                return $ctx.passwordProvider.field.onChange(
                                                  event.target.value
                                                );
                                              }
                                            };
                                            return (({ customFunction }) => {
                                              return customFunction();
                                            })?.apply(null, [actionArgs]);
                                          })()
                                        : undefined;
                                      if (
                                        $steps["runCode"] != null &&
                                        typeof $steps["runCode"] === "object" &&
                                        typeof $steps["runCode"].then ===
                                          "function"
                                      ) {
                                        $steps["runCode"] = await $steps[
                                          "runCode"
                                        ];
                                      }
                                    }).apply(null, eventArgs);
                                  },
                                  placeholder: ``,
                                  required: false,
                                  showEndIcon: true,
                                  size: "large",
                                  type: "password",
                                  value:
                                    generateStateValueProp($state, [
                                      "passwordInput",
                                      "value"
                                    ]) ?? ""
                                };

                                initializePlasmicStates(
                                  $state,
                                  [
                                    {
                                      name: "passwordInput.value",
                                      initFunc: ({
                                        $props,
                                        $state,
                                        $queries
                                      }) =>
                                        (() => {
                                          try {
                                            return $ctx.passwordProvider.field
                                              .value;
                                          } catch (e) {
                                            if (
                                              e instanceof TypeError ||
                                              e?.plasmicType ===
                                                "PlasmicUndefinedDataError"
                                            ) {
                                              return undefined;
                                            }
                                            throw e;
                                          }
                                        })()
                                    }
                                  ],
                                  []
                                );
                                return (
                                  <TextInput
                                    data-plasmic-name={"passwordInput"}
                                    data-plasmic-override={
                                      overrides.passwordInput
                                    }
                                    {...child$Props}
                                  />
                                );
                              })()}
                            </div>
                          )}
                        </DataCtxReader__>
                      </FormControlProvider>
                      <Button
                        data-plasmic-name={"logInBtn"}
                        data-plasmic-override={overrides.logInBtn}
                        aria-label={"Log in"}
                        className={classNames("__wab_instance", sty.logInBtn)}
                        color={"primary"}
                        isDisabled={(() => {
                          try {
                            return $props.isLoggingWithToken;
                          } catch (e) {
                            if (
                              e instanceof TypeError ||
                              e?.plasmicType === "PlasmicUndefinedDataError"
                            ) {
                              return [];
                            }
                            throw e;
                          }
                        })()}
                        size={"large"}
                        submitsForm={true}
                      >
                        {(() => {
                          try {
                            return (
                              !$state.isFormSubmitting &&
                              !$props.isLoggingWithToken
                            );
                          } catch (e) {
                            if (
                              e instanceof TypeError ||
                              e?.plasmicType === "PlasmicUndefinedDataError"
                            ) {
                              return true;
                            }
                            throw e;
                          }
                        })() ? (
                          <div
                            data-plasmic-name={"text"}
                            data-plasmic-override={overrides.text}
                            className={classNames(
                              projectcss.all,
                              projectcss.__wab_text,
                              sty.text
                            )}
                          >
                            {"Log in"}
                          </div>
                        ) : null}
                        {(() => {
                          try {
                            return (
                              $state.isFormSubmitting ||
                              $props.isLoggingWithToken
                            );
                          } catch (e) {
                            if (
                              e instanceof TypeError ||
                              e?.plasmicType === "PlasmicUndefinedDataError"
                            ) {
                              return false;
                            }
                            throw e;
                          }
                        })() ? (
                          <SpinnerIcon
                            data-plasmic-name={"spinnerIcon"}
                            data-plasmic-override={overrides.spinnerIcon}
                            className={classNames(
                              "__wab_instance",
                              sty.spinnerIcon
                            )}
                            disabled={(() => {
                              try {
                                return $props.isLoggingWithToken;
                              } catch (e) {
                                if (
                                  e instanceof TypeError ||
                                  e?.plasmicType === "PlasmicUndefinedDataError"
                                ) {
                                  return [];
                                }
                                throw e;
                              }
                            })()}
                            light={(() => {
                              try {
                                return $state.isFormSubmitting;
                              } catch (e) {
                                if (
                                  e instanceof TypeError ||
                                  e?.plasmicType === "PlasmicUndefinedDataError"
                                ) {
                                  return "light";
                                }
                                throw e;
                              }
                            })()}
                          />
                        ) : null}
                      </Button>
                    </div>
                    <LoginFormSecurity
                      data-plasmic-name={"loginFormSecurity"}
                      data-plasmic-override={overrides.loginFormSecurity}
                      className={classNames(
                        "__wab_instance",
                        sty.loginFormSecurity
                      )}
                    />

                    <LoginFormResources
                      data-plasmic-name={"loginFormResources"}
                      data-plasmic-override={overrides.loginFormResources}
                      className={classNames(
                        "__wab_instance",
                        sty.loginFormResources
                      )}
                    />
                  </form>
                  {(
                    hasVariant(globalVariants, "mobile", "mobile")
                      ? false
                      : hasVariant(globalVariants, "mobile", "tabletPortrait")
                      ? false
                      : true
                  ) ? (
                    <div
                      data-plasmic-name={"line"}
                      data-plasmic-override={overrides.line}
                      className={classNames(projectcss.all, sty.line)}
                    >
                      <PlasmicImg__
                        alt={""}
                        className={classNames(sty.img__uwgCm)}
                        displayHeight={"auto"}
                        displayMaxHeight={"none"}
                        displayMaxWidth={"100%"}
                        displayMinHeight={"0"}
                        displayMinWidth={"0"}
                        displayWidth={"auto"}
                        loader={"plasmic"}
                        loading={"lazy"}
                        src={{
                          src: "https://img.plasmic.app/img-optimizer/v1/img/5d12c32e575d64afdd9b248fa1ad93de.png",
                          fullWidth: 475,
                          fullHeight: 310
                        }}
                      />
                    </div>
                  ) : null}
                </div>
              </section>
            </React.Fragment>
          )}
        </DataCtxReader__>
      </FormProvider>
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: [
    "root",
    "loginForm",
    "multiFactorAuthModal",
    "section",
    "wrapper",
    "heading",
    "logo",
    "link",
    "form",
    "header",
    "title",
    "desc",
    "serviceMessage",
    "notice",
    "bottom",
    "usernameProvider",
    "usernameWrapper",
    "label",
    "onChangeProvider",
    "usernameInput",
    "passwordProvider",
    "password",
    "passwordLabels",
    "label7",
    "label9",
    "passwordInput",
    "logInBtn",
    "text",
    "spinnerIcon",
    "loginFormSecurity",
    "loginFormResources",
    "line"
  ],
  loginForm: [
    "loginForm",
    "multiFactorAuthModal",
    "section",
    "wrapper",
    "heading",
    "logo",
    "link",
    "form",
    "header",
    "title",
    "desc",
    "serviceMessage",
    "notice",
    "bottom",
    "usernameProvider",
    "usernameWrapper",
    "label",
    "onChangeProvider",
    "usernameInput",
    "passwordProvider",
    "password",
    "passwordLabels",
    "label7",
    "label9",
    "passwordInput",
    "logInBtn",
    "text",
    "spinnerIcon",
    "loginFormSecurity",
    "loginFormResources",
    "line"
  ],
  multiFactorAuthModal: ["multiFactorAuthModal"],
  section: [
    "section",
    "wrapper",
    "heading",
    "logo",
    "link",
    "form",
    "header",
    "title",
    "desc",
    "serviceMessage",
    "notice",
    "bottom",
    "usernameProvider",
    "usernameWrapper",
    "label",
    "onChangeProvider",
    "usernameInput",
    "passwordProvider",
    "password",
    "passwordLabels",
    "label7",
    "label9",
    "passwordInput",
    "logInBtn",
    "text",
    "spinnerIcon",
    "loginFormSecurity",
    "loginFormResources",
    "line"
  ],
  wrapper: [
    "wrapper",
    "heading",
    "logo",
    "link",
    "form",
    "header",
    "title",
    "desc",
    "serviceMessage",
    "notice",
    "bottom",
    "usernameProvider",
    "usernameWrapper",
    "label",
    "onChangeProvider",
    "usernameInput",
    "passwordProvider",
    "password",
    "passwordLabels",
    "label7",
    "label9",
    "passwordInput",
    "logInBtn",
    "text",
    "spinnerIcon",
    "loginFormSecurity",
    "loginFormResources",
    "line"
  ],
  heading: ["heading", "logo", "link"],
  logo: ["logo"],
  link: ["link"],
  form: [
    "form",
    "header",
    "title",
    "desc",
    "serviceMessage",
    "notice",
    "bottom",
    "usernameProvider",
    "usernameWrapper",
    "label",
    "onChangeProvider",
    "usernameInput",
    "passwordProvider",
    "password",
    "passwordLabels",
    "label7",
    "label9",
    "passwordInput",
    "logInBtn",
    "text",
    "spinnerIcon",
    "loginFormSecurity",
    "loginFormResources"
  ],
  header: ["header", "title", "desc"],
  title: ["title"],
  desc: ["desc"],
  serviceMessage: ["serviceMessage"],
  notice: ["notice"],
  bottom: [
    "bottom",
    "usernameProvider",
    "usernameWrapper",
    "label",
    "onChangeProvider",
    "usernameInput",
    "passwordProvider",
    "password",
    "passwordLabels",
    "label7",
    "label9",
    "passwordInput",
    "logInBtn",
    "text",
    "spinnerIcon"
  ],
  usernameProvider: [
    "usernameProvider",
    "usernameWrapper",
    "label",
    "onChangeProvider",
    "usernameInput"
  ],
  usernameWrapper: [
    "usernameWrapper",
    "label",
    "onChangeProvider",
    "usernameInput"
  ],
  label: ["label"],
  onChangeProvider: ["onChangeProvider"],
  usernameInput: ["usernameInput"],
  passwordProvider: [
    "passwordProvider",
    "password",
    "passwordLabels",
    "label7",
    "label9",
    "passwordInput"
  ],
  password: ["password", "passwordLabels", "label7", "label9", "passwordInput"],
  passwordLabels: ["passwordLabels", "label7", "label9"],
  label7: ["label7"],
  label9: ["label9"],
  passwordInput: ["passwordInput"],
  logInBtn: ["logInBtn", "text", "spinnerIcon"],
  text: ["text"],
  spinnerIcon: ["spinnerIcon"],
  loginFormSecurity: ["loginFormSecurity"],
  loginFormResources: ["loginFormResources"],
  line: ["line"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  loginForm: typeof FormProvider;
  multiFactorAuthModal: typeof MultiFactorAuthModal;
  section: "section";
  wrapper: "div";
  heading: "div";
  logo: "a";
  link: "div";
  form: "form";
  header: "div";
  title: "h1";
  desc: "p";
  serviceMessage: typeof ServiceMessage;
  notice: typeof Notice;
  bottom: "div";
  usernameProvider: typeof FormControlProvider;
  usernameWrapper: "div";
  label: "label";
  onChangeProvider: typeof OnChangeProvider;
  usernameInput: typeof TextInput;
  passwordProvider: typeof FormControlProvider;
  password: "div";
  passwordLabels: "div";
  label7: "label";
  label9: "a";
  passwordInput: typeof TextInput;
  logInBtn: typeof Button;
  text: "div";
  spinnerIcon: typeof SpinnerIcon;
  loginFormSecurity: typeof LoginFormSecurity;
  loginFormResources: typeof LoginFormResources;
  line: "div";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicLoginForm__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicLoginForm__VariantsArgs;
    args?: PlasmicLoginForm__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & Omit<PlasmicLoginForm__VariantsArgs, ReservedPropsType> & // Specify variants directly as props
    // Specify args directly as props
    Omit<PlasmicLoginForm__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicLoginForm__ArgProps,
          internalVariantPropNames: PlasmicLoginForm__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicLoginForm__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicLoginForm";
  } else {
    func.displayName = `PlasmicLoginForm.${nodeName}`;
  }
  return func;
}

export const PlasmicLoginForm = Object.assign(
  // Top-level PlasmicLoginForm renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    loginForm: makeNodeComponent("loginForm"),
    multiFactorAuthModal: makeNodeComponent("multiFactorAuthModal"),
    section: makeNodeComponent("section"),
    wrapper: makeNodeComponent("wrapper"),
    heading: makeNodeComponent("heading"),
    logo: makeNodeComponent("logo"),
    link: makeNodeComponent("link"),
    form: makeNodeComponent("form"),
    header: makeNodeComponent("header"),
    title: makeNodeComponent("title"),
    desc: makeNodeComponent("desc"),
    serviceMessage: makeNodeComponent("serviceMessage"),
    notice: makeNodeComponent("notice"),
    bottom: makeNodeComponent("bottom"),
    usernameProvider: makeNodeComponent("usernameProvider"),
    usernameWrapper: makeNodeComponent("usernameWrapper"),
    label: makeNodeComponent("label"),
    onChangeProvider: makeNodeComponent("onChangeProvider"),
    usernameInput: makeNodeComponent("usernameInput"),
    passwordProvider: makeNodeComponent("passwordProvider"),
    password: makeNodeComponent("password"),
    passwordLabels: makeNodeComponent("passwordLabels"),
    label7: makeNodeComponent("label7"),
    label9: makeNodeComponent("label9"),
    passwordInput: makeNodeComponent("passwordInput"),
    logInBtn: makeNodeComponent("logInBtn"),
    text: makeNodeComponent("text"),
    spinnerIcon: makeNodeComponent("spinnerIcon"),
    loginFormSecurity: makeNodeComponent("loginFormSecurity"),
    loginFormResources: makeNodeComponent("loginFormResources"),
    line: makeNodeComponent("line"),

    // Metadata about props expected for PlasmicLoginForm
    internalVariantProps: PlasmicLoginForm__VariantProps,
    internalArgProps: PlasmicLoginForm__ArgProps
  }
);

export default PlasmicLoginForm;
/* prettier-ignore-end */
